import { atom, useAtom } from 'jotai';

export const d9AddressAtom = atom<string | undefined>(undefined);

export function useD9Address() {
  const [d9Address, setD9Address] = useAtom(d9AddressAtom);

  useEffect(() => {
    if (window.d9d) {
      window.d9d.exec(
        'getWalletData',
        {},
        (data) => {
          if (data.userProfile.address) {
            setD9Address(data.userProfile.address);
          }
        },
        () => {},
      );
    }
  }, [setD9Address]);

  return d9Address;
}
